export default {"src":"/login-app/[GIT_HASH]/_next/static/media/chart_bar.0b4c197c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};